.categoriesLabel > span {
	display: inline-flex;
	align-items: baseline;
}
